import React from 'react';
import { useData } from '../lib/DataContext.jsx';
import { KpiCard, SectionTitle, SrcBanner, Chip, ProvenanceFooter, ProvenanceBadge } from '../components/ui/kits.jsx';

export default function SdgAlignment() {
  const { data } = useData();
  if (!data) return null;
  const s = data.sdg;

  const sdgByNumber = Object.fromEntries(s.sdgs.map((x) => [x.n, x]));

  return (
    <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 18 }} data-testid="page-sdg">
      <SrcBanner source={s.source} />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
        <KpiCard testid="kpi-sdg-advanced" hero label="SDGs Advanced" value={`${s.count}`} sub={`of ${s.total} Global Goals`} />
        <KpiCard testid="kpi-focus-mapped" label="Focus Areas Mapped" value={String(s.areas.length)} sub="Direct programme alignment" />
        <KpiCard testid="kpi-geo-reach" label="Geographic Reach" value={`${data.reach.kpis.states}+${data.reach.kpis.uts}`} sub="States + UTs" />
      </div>

      <div className="card" style={{ padding: 18 }}>
        <SectionTitle right={<ProvenanceBadge kind="report" />}>SDG Cards · advanced by Parivartan</SectionTitle>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 12 }}>
          {s.sdgs.map((sdg) => (
            <div key={sdg.n} style={{
              padding: 14,
              borderTop: `4px solid ${sdg.color}`,
              border: '1px solid var(--line)',
              borderRadius: 10,
              background: 'var(--surface)',
            }} data-testid={`sdg-${sdg.n}`}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 8, background: sdg.color, color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 800, fontSize: 18,
                }} className="tabular">
                  {sdg.n}
                </div>
                <div style={{ fontWeight: 800, fontSize: 13, color: 'var(--ink)' }}>{sdg.name}</div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {sdg.areas.map((a) => (
                  <span key={a} style={{
                    fontSize: 10, padding: '3px 7px', borderRadius: 4,
                    background: `${sdg.color}15`, color: sdg.color, fontWeight: 600,
                  }}>{a}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="card" style={{ padding: 18 }}>
        <SectionTitle right={<ProvenanceBadge kind="report" note="Focus areas mapped to SDGs by HDFC Parivartan Report" />}>Focus Area → SDG Map</SectionTitle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {s.areas.map((row) => (
            <div key={row.area} style={{
              display: 'grid', gridTemplateColumns: '220px 1fr',
              alignItems: 'center', gap: 12, padding: '10px 12px',
              border: '1px solid var(--line)', borderRadius: 10, background: 'var(--surface-2)',
            }} data-testid={`area-${row.area}`}>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{row.area}</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {row.sdgs.map((n) => {
                  const sd = sdgByNumber[n];
                  const color = sd?.color || '#6b7691';
                  return (
                    <div key={n} title={sd?.name}
                      style={{
                        width: 32, height: 32, background: color, color: '#fff',
                        borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 800, fontSize: 14,
                      }}
                      className="tabular"
                    >
                      {n}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      <ProvenanceFooter text={`SDG advancement figures are programme-wide per the ${s.source}. Colours use official UN SDG palette. Distinct from the OECD-assessed 186-project cohort.`} />
    </div>
  );
}
